import "./InfiniteLoader.scss";

const InfiniteLoader = () => {
  return <div className="infinite-loder"></div>;
};

export default InfiniteLoader;
